"use client";

import { useEffect, useRef, type ReactNode } from "react";
import { observeReveal, showReveal } from "@/lib/reveal";

/*
 * Scroll-reveal without an animation library: the home page has dozens of these, and a framer component per
 * block made hydration the main cost before first paint (see lib/reveal.ts).
 */
export function HReveal({
  children,
  delay = 0,
  x = 0,
  y = 28,
  scale = 1,
  className,
}: {
  children: ReactNode;
  delay?: number;
  x?: number;
  y?: number;
  scale?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const cfg = { duration: reduce ? 0 : 0.65, delay: reduce ? 0 : delay };
    if (reduce) {
      showReveal(el, cfg);
      return;
    }
    return observeReveal(el, cfg, 60);
  }, [delay]);

  return (
    <div
      ref={ref}
      className={className}
      style={{ opacity: 0, transform: `translate3d(${x}px, ${y}px, 0) scale(${scale})` }}
    >
      {children}
    </div>
  );
}
